import { Box, Button, Dialog, DialogContent, IconButton, TextField } from '@mui/material';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader'
import { Close } from '../../../../core/global/Icons';
import { env } from '../../../../core/Env';
import { rqx } from '../../../../core/request/API';
import { useState } from 'react';
export const NewExam = ({dialog, exams, input, setDialog, setExams, setisAlert, setInput, __SESSION, setDisable}) => {
    const [exam, setExam] = useState({name: '', country: ''})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const handleInput = (e) => {
        setExam({...exam, name: e.target.value})
    }
    const handleSave = async() => {
        if(exam.name === ''){
            setError('!valid')
        }else{
            setLoading(true)
            if(input.type === 0){
                let save = await rqx.post(`<<tool>>/${env()}/certification/create`,{"name": exam.name, 'is_default': 0, 'created_by': parseInt(window.atob(__SESSION.ainfo.aid).split('_')[1])})
                if(save.msg === 'success'){
                    setExams([...exams, {id: save.id, name: exam.name}])
                    setInput({...input, name: exam.name})
                }else{
                    setError('exist')
                }
            }else{
                let save = await rqx.post(`<<tool>>/${env()}/licensure/create`,{"name": exam.name, 'is_default': 0, 'created_by': parseInt(window.atob(__SESSION.ainfo.aid).split('_')[1])})
                if(save.msg === 'exam-exist'){
                    setError('exist')
                }else{
                    setExams([...exams, {id: save.id, name: exam.name}])
                    setInput({...input, name: exam.name})
                }
            }
            setDialog({open: false, name: null})
            setisAlert(true)
            setDisable(false)
        }
    }
    return (
        <Dialog open={dialog.open} PaperProps={{sx:{borderRadius: '16px', width:'500px'}}}>
            <DialogContent>
                <Box display="flex" alignItems="center">
                    <Box fontSize="18px" fontWeight={600}>Type the {input.type === 0 ? 'certification' : 'licensure'} you want to add in SUREiPASS</Box>
                    <IconButton sx={{border: '1px solid #E5EBF6', borderRadius: '6px', padding: '3px'}} onClick={()=>setDialog({open: false, name: null})}><Close /></IconButton>
                </Box>
                <Box fontSize="14px" mb="5px" mt="10px">Name of {input.type === 0 ? 'Certification' : 'Licensure'}:</Box>
                <TextField id="outlined-basic" variant="outlined" fullWidth name="certification" value={exam.name} onChange={(e)=>handleInput(e)} error={error === null ? false : true} helperText={error === null ? '' : (error === 'exist' ? 'Name already exist' : 'This field is required')}/>
                <Box display="flex" justifyContent="flex-end" alignItems="center" mt="24px">
                    {
                        loading ? (
                            <Box bgcolor="#256EFF" borderRadius="8px" p="5px 16px" width="70px">
                                <Box height="26px" display="flex" alignItems="center" justifyContent="center"><SnakeLoader size="8px" bg="#fff" distance="0.1rem" /></Box>
                            </Box>
                        ) : (
                            <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
                        )
                    }
                </Box>
            </DialogContent>
        </Dialog>
    )
}